import { Component } from '@angular/core';

@Component({
  selector: 'app-footer-links',
  templateUrl: './footer-links.component.html',
  styleUrls: ['./footer-links.component.css'],
  standalone: false
})
export class FooterLinksComponent {

}
